export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';



// WEBPACK FOOTER //
// ./src/actions/password/types.js